module.exports = __webpack_public_path__ + "img/4.e881e006.jpg";